import React from 'react';

/**
 * What a standings board shows somebody who isn't in a pool yet.
 *
 * It used to show them the ungated board: every entry in the database, including
 * strangers' — so a brand-new arrival read "8 Players in pool" and "#6 Your rank"
 * while belonging to nothing, with a podium of people they had never met. The app
 * looked like it was working. Nothing on the screen said their picks were scoring
 * nowhere, so the reasonable conclusion was that they were set up and done, and
 * the reason to ever create or join a pool never arrived.
 *
 * The reassurance is the important half and it is literally true: a personal
 * entry is adopted by the first pool you join — same entry, same picks, straight
 * onto that pool's board. Saying so turns "you did this wrong" into "you're one
 * step from counting", which is the step we actually want them to take.
 */
const LEAD = {
  standings: 'This board ranks you against the other people in your pool.',
  season:    'Season standings rank you against the other people in your pool.',
  recap:     "A recap shows how your pool's week finished, who won it, and where you came."
};

export default function NoPoolYet({ onGoToPools, board = 'standings' }) {
  return (
    <div style={{ padding: '24px 20px', maxWidth: 640, margin: '0 auto' }}>
      <div style={{
        background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(127,179,255,0.18)',
        borderRadius: 14, padding: '32px 24px', textAlign: 'center'
      }}>
        <div style={{ fontSize: 40, marginBottom: 14 }}>🏆</div>
        <div style={{
          fontFamily: "'Oswald', sans-serif", fontSize: 21, fontWeight: 700,
          color: '#dde', marginBottom: 10
        }}>
          You're not in a pool yet
        </div>
        <div style={{ color: '#889', fontSize: 14, lineHeight: 1.6, marginBottom: 8 }}>
          {LEAD[board] || LEAD.standings}
          {' '}Start one and share the code, or join with a code someone sent you.
        </div>
        <div style={{ color: '#667', fontSize: 13, lineHeight: 1.6, marginBottom: 20 }}>
          Any picks you've already made are saved. They'll come with you into the
          first pool you join and start counting right away.
        </div>
        <button
          onClick={onGoToPools}
          style={{
            padding: '12px 26px', borderRadius: 8, border: 'none', cursor: 'pointer',
            fontFamily: "'Oswald', sans-serif", fontSize: 14, fontWeight: 700, letterSpacing: 1,
            background: 'linear-gradient(135deg,#D50A0A,#a00808)', color: '#fff'
          }}
        >🏆 CREATE OR JOIN A POOL</button>
      </div>
    </div>
  );
}
